import React, { useCallback } from 'react'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';

// Set Center
const FormAlign_3 = () => {
  const SetCameraFront  = Control.Get('SetCameraFront');
  const SetCameraOut  = Control.Get('SetCameraOut');

  const style          = SideStyle();
  const align          = Param.Get('align');
  const setParam       = Param.Get('setParam');
  const setup          = Param.Get('setup');

  const onClick = useCallback((n) => {
    setParam(s => {s.align.stepCenter = n});

    if( n==0 ) {
      SetCameraFront()
    } else if( n==1) {
      SetCameraOut(setup.side, 0);
    }
  });
  
  /**
   * Returns the active button style based on the current step center.
   * @param {number} n - The step center number to compare with.
   * @returns {string} - The button style.
   */
  function getActive(n){
    return (align.stepCenter == n) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }

  return (
    <div className={style.outside2}>
      <Grid container spacing={1} alignItems='center'>
        {/* S20 */}
        <Grid item xs={6}>
          <Button name="step" className={getActive(0)} onClick={() => onClick(0)} size="small" >Front/Back</Button>
        </Grid>

        {/* S21 */}
        <Grid item xs={6}>
          <Button name="step" className={getActive(1)} onClick={() => onClick(1)} size="small" >Side</Button>
        </Grid>
      </Grid>
    </div>
  );
}
export default FormAlign_3;
